export type RegraRow = {
    id?: number
    nome: string
    acao: AcaoType
    rating1: number
    rating2: number
    enviarNotificacao: boolean
    emailsNotificacao: string
    condicoes?: CondicaoRow[]
}

export type AcaoType = 'BLOQUEAR' | 'ALERTAR' | 'LIBERAR'

export type CondicaoRow = {
    id?: number
    fonteDados: FonteDadosTipo
    campoFonteDados: CampoFonteDadosEnum
    comparacao: ComparacaoTipo
    valor1: string
    valor2: string
    tipo: 'E' | 'OU'
}

export const COMPARACAO_TIPO = new Map<string, string>([
    ['IGUAL', 'Igual'],
    ['DIFERENTE', 'Diferente'],
    ['CONTENHA', 'Contenha'],
    ['NAO_CONTENHA', 'Não Contenha'],
    ['INICIA', 'Inicia'],
    ['TERMINA', 'Termina'],
    ['ENTRE', 'Entre'],
    ['MAIOR', 'Maior'],
    ['MAIOR_IGUAL', 'Maior ou Igual'],
    ['MENOR', 'Menor'],
    ['MENOR_IGUAL', 'Menor ou Igual']
])

type ComparacaoTipo = typeof COMPARACAO_TIPO extends Map<infer K, unknown> ? K : never

export const FONTE_DADOS_TIPO = new Map<string, string>([
    ['CFOP', 'Cfop'],
    ['CNAE', 'Cnae'],
    ['CVM', 'CVM'],
    ['DISTANCIA', 'Distância'],
    ['DOMINIO', 'Domínio'],
    ['GEOLOCALIZACAO', 'Geolocalização'],
    ['IMPOSTOS', 'Impostos'],
    ['INTEGRACAO', 'Integração'],
    ['INTEGRACAO_LOTE', 'Integração Lote'],
    ['INTEGRACAO_EXTRATRO_LOTE', 'Integração Extrato Lote'],
    ['INTEGRACAO_INVESTIDO', 'Integração Investido'],
    ['MUNICIPIO_FRONTEIRICO', 'Município Fronteiriço'],
    ['NFE', 'NFe'],
    ['PESQUISA_WEB', 'Pesquisa Web'],
    ['PF', 'Pessoa Física'],
    ['RECEITA_FEDERAL', 'Receita Federal'],
    ['RELACIONAMENTO', 'Relacionamento'],
    ['RJ_FALENCIA', 'RJ - Falência'],
    ['SEFAZ', 'Sefaz'],
    ['SERASA', 'Serasa'],
    ['PROTESTO', 'Protestos'],
    ['SIMPLES_NACIONAL', 'Simples Nacional'],
    ['SOCIOS', 'Sócios'],
    ['SOCIOS_PARTICIPACAO', 'Sócios Participação'],
    ['SOCIOS_RJ', 'Sócios RJ'],
    ['SPC_BRASIL', 'SPC Brasil'],
    ['TITULO', 'Título']
])

type FonteDadosTipo = typeof FONTE_DADOS_TIPO extends Map<infer K, unknown> ? K : never

export enum CampoFonteDadosEnum {
    // :: RECEITA FEDERAL
    FATURAMENTO_ESTIMADO = 'FATURAMENTO_ESTIMADO',
    DATA_FUNDACAO_MATRIZ_ANOS = 'DATA_FUNDACAO_MATRIZ_ANOS',
    DATA_FUNDACAO_MATRIZ_MESES = 'DATA_FUNDACAO_MATRIZ_MESES',
    SITUACAO_FILIAL = 'SITUACAO_FILIAL',
    SITUACAO_MATRIZ = 'SITUACAO_MATRIZ',
    NATUREZA_JURIDICA = 'NATUREZA_JURIDICA',
    CAPITAL_SOCIAL = 'CAPITAL_SOCIAL',
    CEDENTE_SACADO_DOC_RAIZ_IGUAL = 'CEDENTE_SACADO_DOC_RAIZ_IGUAL',
    CEDENTE_SACADO_TELEFONE_IGUAL = 'CEDENTE_SACADO_TELEFONE_IGUAL',
    CEDENTE_SACADO_EMAIL_IGUAL = 'CEDENTE_SACADO_EMAIL_IGUAL',
    CEDENTE_SACADO_DOMINIO_IGUAL = 'CEDENTE_SACADO_DOMINIO_IGUAL',
    SOCIO_PEP_CPF = 'SOCIO_PEP_CPF',
    PF_TEM_PEP = 'PF_TEM_PEP',
    // :: CNAE
    CNAE_GRUPO = 'CNAE_GRUPO',
    // :: PROTESTO
    PROTESTO_DIAS_ULTIMO_PROTESTO = 'PROTESTO_DIAS_ULTIMO_PROTESTO',
    PROTESTO_QTD = 'PROTESTO_QTD',
    PROTESTO_QTD_1_15_dias = 'PROTESTO_QTD_1_15_dias',
    PROTESTO_QTD_16_30_dias = 'PROTESTO_QTD_16_30_dias',
    PROTESTO_QTD_31_60_dias = 'PROTESTO_QTD_31_60_dias',
    PROTESTO_QTD_61_90_dias = 'PROTESTO_QTD_61_90_dias',
    PROTESTO_VALOR_TOTAL = 'PROTESTO_VALOR_TOTAL',
    PORC_VALOR_PROTESTOS_SOBRE_FAT_ESTIMADO_MENSAL = 'PORC_VALOR_PROTESTOS_SOBRE_FAT_ESTIMADO_MENSAL',
    // :: SERASA
    DIVIDA_VENCIDA_SOBRE_FAT_MENSAL_PORC = 'DIVIDA_VENCIDA_SOBRE_FAT_MENSAL_PORC',
    ULTIMA_ALTERACAO_COMPOSICAO_SOCIETARIA_MESES = 'ULTIMA_ALTERACAO_COMPOSICAO_SOCIETARIA_MESES',
    EVOLUCAO_CONSULTAS_ULTIMOS_6_MESES_PORC = 'EVOLUCAO_CONSULTAS_ULTIMOS_6_MESES_PORC',
    QTD_MEDIA_CONSULTAS_ULTIMOS_3_MESES = 'QTD_MEDIA_CONSULTAS_ULTIMOS_3_MESES',
    PEFIN_QTD = 'PEFIN_QTD',
    PEFIN_VLR_TOTAL = 'PEFIN_VLR_TOTAL',
    REFIN_QTD = 'REFIN_QTD',
    REFIN_VLR_TOTAL = 'REFIN_VLR_TOTAL',
    PERCENTUAL_REFIN_PEFIN_SOBRE_FAT_ESTIMADO = 'PERCENTUAL_REFIN_PEFIN_SOBRE_FAT_ESTIMADO',
    HIST_PAG_MEDIA_3_MESES = 'HIST_PAG_MEDIA_3_MESES',
    LIMINAR = 'LIMINAR',
    // CHEQUE_DEVOLVIDO_QTD = 'CHEQUE_DEVOLVIDO_QTD', ??
    POSSUI_VISAO_CEDENTE = 'POSSUI_VISAO_CEDENTE',

    // :: NFE
    NFE_AUTORIZACAO_USO_SIM_NAO = 'NFE_AUTORIZACAO_USO_SIM_NAO',
    DATA_NOTA_DIAS = 'DATA_NOTA_DIAS',
    CFOP_COMPLETO = 'CFOP_COMPLETO',
    TIPO_OPERACAO = 'TIPO_OPERACAO',
    NFE_MONITORADA = 'NFE_MONITORADA',
    NFE_FEZ_CONSULTA = 'NFE_FEZ_CONSULTA',
    CTE_AUTORIZADO = 'CTE_AUTORIZADO',
    CTE_CANCELADO = 'CTE_CANCELADO',
    MDFE_AUTORIZADO = 'MDFE_AUTORIZADO',
    MDFE_CANCELADO = 'MDFE_CANCELADO',
    MDFE_AUTORIZADO_COM_CTE = 'MDFE_AUTORIZADO_COM_CTE',
    MDFE_CANCELADO_COM_CTE = 'MDFE_CANCELADO_COM_CTE',
    CARTA_CORRECAO = 'CARTA_CORRECAO',
    NFE_DESCONHECIMENTO_OPERACAO = 'NFE_DESCONHECIMENTO_OPERACAO',
    NFE_CANCELAMENTO_PELO_EMITENTE = 'NFE_CANCELAMENTO_PELO_EMITENTE',

    // :: TITULOS
    TITULO_PRAZO = 'TITULO_PRAZO',
    TITULO_POSSUI_NFE = 'TITULO_POSSUI_NFE',
    TITULO_VALOR_IGUAL_VALOR_TITULO_NFE = 'TITULO_VALOR_IGUAL_VALOR_TITULO_NFE',
    TITULO_DOCUMENTO_IGUAL_DOCUMENTO_TITULO_NFE = 'TITULO_DOCUMENTO_IGUAL_DOCUMENTO_TITULO_NFE',
    TITULO_VENCIMENTO_IGUAL_VENCIMENTO_TITULO_NFE = 'TITULO_VENCIMENTO_IGUAL_VENCIMENTO_TITULO_NFE',

    // :: INTEGRAÇÃO
    INTEGRACAO_SACADO_BLOQUEADO = 'INTEGRACAO_SACADO_BLOQUEADO',
    INTEGRACAO_SACADO_MONITORADO_COMO_CEDENTE = 'INTEGRACAO_SACADO_MONITORADO_COMO_CEDENTE',

    // :: RJ FALENCIA
    FALENCIA_STATUS = 'FALENCIA_STATUS',
    DIAS_ULTIMA_FALENCIA_REQUERIDA = 'DIAS_ULTIMA_FALENCIA_REQUERIDA',
    TEMPO_ULTIMA_FALENCIA_EXTINTA_ANOS = 'TEMPO_ULTIMA_FALENCIA_EXTINTA_ANOS',
    RF_FALIDO = 'RF_FALIDO',
    RJ_STATUS = 'RJ_STATUS',
    DIAS_ULTIMA_RJ_REQUERIDA = 'DIAS_ULTIMA_RJ_REQUERIDA',
    RF_RECUPERACAO_JUDICIAL = 'RF_RECUPERACAO_JUDICIAL',

    // :: PF
    PF_CONFIRMACAO_FALECIMENTO = 'PF_CONFIRMACAO_FALECIMENTO'
}

export const CAMPO_FONTE_DADOS_TIPO: Record<string, Map<CampoFonteDadosEnum, string>> = {
    ['RECEITA_FEDERAL']: new Map<CampoFonteDadosEnum, string>([
        [CampoFonteDadosEnum.FATURAMENTO_ESTIMADO, 'Faturamento estimado'],
        [CampoFonteDadosEnum.DATA_FUNDACAO_MATRIZ_ANOS, 'Data Fundação Matriz (anos)'],
        [CampoFonteDadosEnum.DATA_FUNDACAO_MATRIZ_MESES, 'Data Fundação Matriz (meses)'],
        [CampoFonteDadosEnum.SITUACAO_FILIAL, 'Situação Filial'],
        [CampoFonteDadosEnum.SITUACAO_MATRIZ, 'Situação Matriz'],
        [CampoFonteDadosEnum.NATUREZA_JURIDICA, 'Natureza Jurídica'],
        [CampoFonteDadosEnum.CAPITAL_SOCIAL, 'Capital Social'],
        [CampoFonteDadosEnum.CEDENTE_SACADO_DOC_RAIZ_IGUAL, 'Cedente e sacado com a mesma raiz de cnpj'],
        [CampoFonteDadosEnum.CEDENTE_SACADO_TELEFONE_IGUAL, 'Cedente e sacado com o mesmo telefone'],
        [CampoFonteDadosEnum.CEDENTE_SACADO_EMAIL_IGUAL, 'Cedente e sacado com o mesmo email'],
        [CampoFonteDadosEnum.CEDENTE_SACADO_DOMINIO_IGUAL, 'Cedente e sacado com o mesmo dominio'],
        [CampoFonteDadosEnum.SOCIO_PEP_CPF, 'Sócios PEP (CPF)']
    ]),
    ['CNAE']: new Map<CampoFonteDadosEnum, string>([[CampoFonteDadosEnum.CNAE_GRUPO, 'Cnae Grupo']]),
    ['SERASA']: new Map<CampoFonteDadosEnum, string>([
        [CampoFonteDadosEnum.DIVIDA_VENCIDA_SOBRE_FAT_MENSAL_PORC, 'Dívida Vencida Sobre Faturamento Mensal (%)'],
        [
            CampoFonteDadosEnum.ULTIMA_ALTERACAO_COMPOSICAO_SOCIETARIA_MESES,
            'Última alteração da composição societária (Meses)'
        ],
        [
            CampoFonteDadosEnum.EVOLUCAO_CONSULTAS_ULTIMOS_6_MESES_PORC,
            'Evolução consulta em relação aos últimos 6 meses (%)'
        ],
        [CampoFonteDadosEnum.QTD_MEDIA_CONSULTAS_ULTIMOS_3_MESES, 'Consulta Serasa med. 3 últimos meses (Qtd)'],
        [CampoFonteDadosEnum.PEFIN_QTD, 'PEFIN (Qtd)'],
        [CampoFonteDadosEnum.PEFIN_VLR_TOTAL, 'PEFIN (Valor)'],
        [CampoFonteDadosEnum.REFIN_QTD, 'REFIN (Qtd)'],
        [CampoFonteDadosEnum.REFIN_VLR_TOTAL, 'REFIN (Valor)'],
        [CampoFonteDadosEnum.PERCENTUAL_REFIN_PEFIN_SOBRE_FAT_ESTIMADO, 'Pefin + Refin x % Fat. Estimado'],
        [CampoFonteDadosEnum.HIST_PAG_MEDIA_3_MESES, 'Hist. de pag. média 3 meses (%)'],
        [CampoFonteDadosEnum.POSSUI_VISAO_CEDENTE, 'Possui visão cedente'],
        [CampoFonteDadosEnum.LIMINAR, 'Liminar'],
        
        // [CampoFonteDadosEnum.CHEQUE_DEVOLVIDO_QTD, 'Cheque Devolvido (Qtd)'],
    ]),
    ['PROTESTO']: new Map<CampoFonteDadosEnum, string>([
        [CampoFonteDadosEnum.PROTESTO_DIAS_ULTIMO_PROTESTO, 'Dias do último protesto'],
        [CampoFonteDadosEnum.PROTESTO_QTD, 'Protesto (Qtd)'],
        [CampoFonteDadosEnum.PROTESTO_QTD_1_15_dias, 'Protestos de 1 a 15 dias (Qtd)'],
        [CampoFonteDadosEnum.PROTESTO_QTD_16_30_dias, 'Protestos de 16 a 30 dias (Qtd)'],
        [CampoFonteDadosEnum.PROTESTO_QTD_31_60_dias, 'Protestos de 31 a 60 dias (Qtd)'],
        [CampoFonteDadosEnum.PROTESTO_QTD_61_90_dias, 'Protestos de 61 a 90 dias (Qtd)'],
        [CampoFonteDadosEnum.PROTESTO_VALOR_TOTAL, 'Protesto (Valor)'],
        [
            CampoFonteDadosEnum.PORC_VALOR_PROTESTOS_SOBRE_FAT_ESTIMADO_MENSAL,
            'Protestos x faturamento estimado mensal (%)'
        ]
    ]),

    ['NFE']: new Map<CampoFonteDadosEnum, string>([
        [CampoFonteDadosEnum.NFE_AUTORIZACAO_USO_SIM_NAO, 'Autorização de Uso'],
        [CampoFonteDadosEnum.DATA_NOTA_DIAS, 'Data da Nota (Dias)'],
        [CampoFonteDadosEnum.CFOP_COMPLETO, 'CFOP - Completo'],
        [CampoFonteDadosEnum.TIPO_OPERACAO, 'Tipo de Operação'],
        [CampoFonteDadosEnum.NFE_MONITORADA, 'NFE monitorada'],
        [CampoFonteDadosEnum.NFE_FEZ_CONSULTA, 'Fez consulta'],
        [CampoFonteDadosEnum.CTE_AUTORIZADO, 'CT-e Autorizado'],
        [CampoFonteDadosEnum.CTE_CANCELADO, 'CT-e Cancelado'],
        [CampoFonteDadosEnum.MDFE_AUTORIZADO, 'MDF-e Autorizado'],
        [CampoFonteDadosEnum.MDFE_CANCELADO, 'MDF-e Cancelado'],
        [CampoFonteDadosEnum.MDFE_AUTORIZADO_COM_CTE, 'MDF-e Autorizado com CT-e'],
        [CampoFonteDadosEnum.MDFE_CANCELADO_COM_CTE, 'MDF-e Cancelado com CT-e'],
        [CampoFonteDadosEnum.CARTA_CORRECAO, 'Carta de Correção'],
        [CampoFonteDadosEnum.NFE_DESCONHECIMENTO_OPERACAO, 'Desconhecimento da Operação'],
        [CampoFonteDadosEnum.NFE_CANCELAMENTO_PELO_EMITENTE, 'Cancelamento pelo Emitente']
    ]),
    ['PF']: new Map<CampoFonteDadosEnum, string>([
        [CampoFonteDadosEnum.PF_TEM_PEP, 'Tem PEP'],
        [CampoFonteDadosEnum.PF_CONFIRMACAO_FALECIMENTO, 'Confirmação de Falecimento']
    ]),
    ['CFOP']: new Map<CampoFonteDadosEnum, string>([]),
    ['CVM']: new Map<CampoFonteDadosEnum, string>([]),
    ['DISTANCIA']: new Map<CampoFonteDadosEnum, string>([]),
    ['DOMINIO']: new Map<CampoFonteDadosEnum, string>([]),
    ['GEOLOCALIZACAO']: new Map<CampoFonteDadosEnum, string>([]),
    ['IMPOSTOS']: new Map<CampoFonteDadosEnum, string>([]),
    ['INTEGRACAO']: new Map<CampoFonteDadosEnum, string>([
        [CampoFonteDadosEnum.INTEGRACAO_SACADO_BLOQUEADO, 'Sacado possui bloqueio'],
        [
            CampoFonteDadosEnum.INTEGRACAO_SACADO_MONITORADO_COMO_CEDENTE,
            'Está em grupo de monitoramento com visão cedente'
        ]
    ]),
    ['INTEGRACAO_LOTE']: new Map<CampoFonteDadosEnum, string>([]),
    ['INTEGRACAO_EXTRATRO_LOTE']: new Map<CampoFonteDadosEnum, string>([]),
    ['INTEGRACAO_INVESTIDO']: new Map<CampoFonteDadosEnum, string>([]),
    ['MUNICIPIO_FRONTEIRICO']: new Map<CampoFonteDadosEnum, string>([]),
    ['PESQUISA_WEB']: new Map<CampoFonteDadosEnum, string>([]),
    ['RELACIONAMENTO']: new Map<CampoFonteDadosEnum, string>([]),
    ['RJ_FALENCIA']: new Map<CampoFonteDadosEnum, string>([
        [CampoFonteDadosEnum.FALENCIA_STATUS, 'Falência'],
        [CampoFonteDadosEnum.DIAS_ULTIMA_FALENCIA_REQUERIDA, 'Dias Última Falência Requerida'],
        [CampoFonteDadosEnum.TEMPO_ULTIMA_FALENCIA_EXTINTA_ANOS, 'Tempo da Última Falência Extinta (Anos)'],
        [CampoFonteDadosEnum.RF_FALIDO, 'RF Falido'],
        [CampoFonteDadosEnum.RJ_STATUS, 'Recuperação Judicial'],
        [CampoFonteDadosEnum.DIAS_ULTIMA_RJ_REQUERIDA, 'Dias Última Recuperação Requerida'],
        [CampoFonteDadosEnum.RF_RECUPERACAO_JUDICIAL, 'RF Recuperação Judicial']
    ]),
    ['SEFAZ']: new Map<CampoFonteDadosEnum, string>([]),
    ['SIMPLES_NACIONAL']: new Map<CampoFonteDadosEnum, string>([]),
    ['SOCIOS']: new Map<CampoFonteDadosEnum, string>([]),
    ['SOCIOS_PARTICIPACAO']: new Map<CampoFonteDadosEnum, string>([]),
    ['SOCIOS_RJ']: new Map<CampoFonteDadosEnum, string>([]),
    ['SPC_BRASIL']: new Map<CampoFonteDadosEnum, string>([]),
    ['TITULO']: new Map<CampoFonteDadosEnum, string>([
        [CampoFonteDadosEnum.TITULO_PRAZO, 'Prazo (Dias)'],
        [CampoFonteDadosEnum.TITULO_POSSUI_NFE, 'Possui Nfe'],
        [CampoFonteDadosEnum.TITULO_VALOR_IGUAL_VALOR_TITULO_NFE, 'Valor item da Nfe'],
        [CampoFonteDadosEnum.TITULO_DOCUMENTO_IGUAL_DOCUMENTO_TITULO_NFE, 'Documento item da Nfe'],
        [CampoFonteDadosEnum.TITULO_VENCIMENTO_IGUAL_VENCIMENTO_TITULO_NFE, 'Vencimento item da Nfe']
    ])
}

type TipoDado = 'texto' | 'numero' | 'opcao' | 'cfop'

interface CampoTipoDado {
    tipo: TipoDado
    opcoes?: { valor: string; label?: string }[] // para tipos 'sim_nao' ou 'opcao'
}

const SituacaoEmpresaType: CampoTipoDado = {
    tipo: 'opcao',
    opcoes: [
        { valor: 'Ativa' },
        { valor: 'Inativa' },
        { valor: 'Suspensa' },
        { valor: 'Inconsistência Cadastral' },
        { valor: 'Inapta' },
        { valor: 'Omissa' },
        { valor: 'Baixada' }
    ]
}
const NaturezaJuridicaType: CampoTipoDado = {
    tipo: 'opcao',
    opcoes: [{ valor: 'Administracao Pública' }, { valor: 'Sociedade de Economia Mista' }]
}
const SimNaoType: CampoTipoDado = {
    tipo: 'opcao',
    opcoes: [{ valor: 'Sim' }, { valor: 'Não' }]
}
const IgualDiferenteType: CampoTipoDado = {
    tipo: 'opcao',
    opcoes: [{ valor: 'Igual' }, { valor: 'Diferente' }]
}
const NumeroType: CampoTipoDado = {
    tipo: 'numero'
}
const TextoType: CampoTipoDado = {
    tipo: 'numero'
}
const CfopType: CampoTipoDado = {
    tipo: 'cfop'
}

export const CAMPO_TIPO_DADO: Record<CampoFonteDadosEnum, CampoTipoDado> = {
    //RECEITA_FEDERAL
    [CampoFonteDadosEnum.FATURAMENTO_ESTIMADO]: NumeroType,
    [CampoFonteDadosEnum.DATA_FUNDACAO_MATRIZ_ANOS]: NumeroType,
    [CampoFonteDadosEnum.DATA_FUNDACAO_MATRIZ_MESES]: NumeroType,
    [CampoFonteDadosEnum.SITUACAO_FILIAL]: SituacaoEmpresaType,
    [CampoFonteDadosEnum.SITUACAO_MATRIZ]: SituacaoEmpresaType,
    [CampoFonteDadosEnum.NATUREZA_JURIDICA]: NaturezaJuridicaType,
    [CampoFonteDadosEnum.CAPITAL_SOCIAL]: NumeroType,
    [CampoFonteDadosEnum.CEDENTE_SACADO_DOC_RAIZ_IGUAL]: SimNaoType,
    [CampoFonteDadosEnum.CEDENTE_SACADO_TELEFONE_IGUAL]: SimNaoType,
    [CampoFonteDadosEnum.CEDENTE_SACADO_EMAIL_IGUAL]: SimNaoType,
    [CampoFonteDadosEnum.CEDENTE_SACADO_DOMINIO_IGUAL]: SimNaoType,
    [CampoFonteDadosEnum.SOCIO_PEP_CPF]: SimNaoType,

    //CNAE
    [CampoFonteDadosEnum.CNAE_GRUPO]: TextoType,

    // PROTESTO
    [CampoFonteDadosEnum.PROTESTO_DIAS_ULTIMO_PROTESTO]: NumeroType,
    [CampoFonteDadosEnum.PROTESTO_QTD]: NumeroType,
    [CampoFonteDadosEnum.PROTESTO_QTD_1_15_dias]: NumeroType,
    [CampoFonteDadosEnum.PROTESTO_QTD_16_30_dias]: NumeroType,
    [CampoFonteDadosEnum.PROTESTO_QTD_31_60_dias]: NumeroType,
    [CampoFonteDadosEnum.PROTESTO_QTD_61_90_dias]: NumeroType,
    [CampoFonteDadosEnum.PROTESTO_VALOR_TOTAL]: NumeroType,
    [CampoFonteDadosEnum.PORC_VALOR_PROTESTOS_SOBRE_FAT_ESTIMADO_MENSAL]: NumeroType,

    //SERASA
    [CampoFonteDadosEnum.DIVIDA_VENCIDA_SOBRE_FAT_MENSAL_PORC]: NumeroType,
    [CampoFonteDadosEnum.ULTIMA_ALTERACAO_COMPOSICAO_SOCIETARIA_MESES]: NumeroType,
    [CampoFonteDadosEnum.EVOLUCAO_CONSULTAS_ULTIMOS_6_MESES_PORC]: NumeroType,
    [CampoFonteDadosEnum.QTD_MEDIA_CONSULTAS_ULTIMOS_3_MESES]: NumeroType,
    [CampoFonteDadosEnum.PEFIN_QTD]: NumeroType,
    [CampoFonteDadosEnum.PEFIN_VLR_TOTAL]: NumeroType,
    [CampoFonteDadosEnum.REFIN_QTD]: NumeroType,
    [CampoFonteDadosEnum.REFIN_VLR_TOTAL]: NumeroType,
    [CampoFonteDadosEnum.PERCENTUAL_REFIN_PEFIN_SOBRE_FAT_ESTIMADO]: NumeroType,
    [CampoFonteDadosEnum.HIST_PAG_MEDIA_3_MESES]: NumeroType,
    [CampoFonteDadosEnum.POSSUI_VISAO_CEDENTE]: SimNaoType,
    [CampoFonteDadosEnum.LIMINAR]: SimNaoType,
    // [CampoFonteDadosEnum.CHEQUE_DEVOLVIDO_QTD, 'Cheque Devolvido (Qtd)'],
    //NFE
    [CampoFonteDadosEnum.NFE_AUTORIZACAO_USO_SIM_NAO]: SimNaoType,
    [CampoFonteDadosEnum.DATA_NOTA_DIAS]: NumeroType,
    [CampoFonteDadosEnum.CFOP_COMPLETO]: CfopType,
    [CampoFonteDadosEnum.TIPO_OPERACAO]: {
        tipo: 'opcao',
        opcoes: [
            { valor: '0', label: 'Entrada' },
            { valor: '1', label: 'Saída' }
        ]
    },
    [CampoFonteDadosEnum.NFE_MONITORADA]: SimNaoType,
    [CampoFonteDadosEnum.NFE_FEZ_CONSULTA]: SimNaoType,
    [CampoFonteDadosEnum.CTE_AUTORIZADO]: SimNaoType,
    [CampoFonteDadosEnum.CTE_CANCELADO]: SimNaoType,
    [CampoFonteDadosEnum.MDFE_AUTORIZADO]: SimNaoType,
    [CampoFonteDadosEnum.MDFE_CANCELADO]: SimNaoType,
    [CampoFonteDadosEnum.MDFE_AUTORIZADO_COM_CTE]: SimNaoType,
    [CampoFonteDadosEnum.MDFE_CANCELADO_COM_CTE]: SimNaoType,
    [CampoFonteDadosEnum.CARTA_CORRECAO]: SimNaoType,
    [CampoFonteDadosEnum.NFE_DESCONHECIMENTO_OPERACAO]: SimNaoType,
    [CampoFonteDadosEnum.NFE_CANCELAMENTO_PELO_EMITENTE]: SimNaoType,

    //INTEGRAÇÃO
    [CampoFonteDadosEnum.INTEGRACAO_SACADO_BLOQUEADO]: SimNaoType,
    [CampoFonteDadosEnum.INTEGRACAO_SACADO_MONITORADO_COMO_CEDENTE]: SimNaoType,

    //PF
    [CampoFonteDadosEnum.PF_TEM_PEP]: SimNaoType,
    [CampoFonteDadosEnum.PF_CONFIRMACAO_FALECIMENTO]: SimNaoType,

    //RJ_FALENCIA
    [CampoFonteDadosEnum.FALENCIA_STATUS]: {
        tipo: 'opcao',
        opcoes: [{ valor: 'Falência Requerida' }, { valor: 'Falência Decretada' }]
    },
    [CampoFonteDadosEnum.DIAS_ULTIMA_FALENCIA_REQUERIDA]: NumeroType,
    [CampoFonteDadosEnum.TEMPO_ULTIMA_FALENCIA_EXTINTA_ANOS]: NumeroType,
    [CampoFonteDadosEnum.RF_FALIDO]: SimNaoType,
    [CampoFonteDadosEnum.RJ_STATUS]: {
        tipo: 'opcao',
        opcoes: [
            { valor: 'RJ Requerida' },
            { valor: 'RJ Concedida' },
            { valor: 'RJ Indeferida' },
            { valor: 'RJ Deferida' }
        ]
    },
    [CampoFonteDadosEnum.DIAS_ULTIMA_RJ_REQUERIDA]: NumeroType,
    [CampoFonteDadosEnum.RF_RECUPERACAO_JUDICIAL]: SimNaoType,

    //TITULO
    [CampoFonteDadosEnum.TITULO_PRAZO]: NumeroType,
    [CampoFonteDadosEnum.TITULO_POSSUI_NFE]: SimNaoType,
    [CampoFonteDadosEnum.TITULO_VALOR_IGUAL_VALOR_TITULO_NFE]: IgualDiferenteType,
    [CampoFonteDadosEnum.TITULO_DOCUMENTO_IGUAL_DOCUMENTO_TITULO_NFE]: IgualDiferenteType,
    [CampoFonteDadosEnum.TITULO_VENCIMENTO_IGUAL_VENCIMENTO_TITULO_NFE]: IgualDiferenteType
}
